import React from 'react';

export default function BlogPullQuote({ data }) {
  const { quote, attribution } = data;
  if (!quote) return null;

  return (
    <div className="blog-pullquote">
      <h2 className="blog-pullquote-text">{quote}</h2>
      {attribution && <span className="blog-pullquote-cite">{attribution}</span>}
    </div>
  );
}
